export const NEWS_CATEGORIES = {
  MARKET_DATA: 'Market Data',
  ESTIMATE: 'Estimate',
  COMPARISON: 'Comparison',
  BID_PACKAGE: 'Bid Package',
  HISTORICAL_RECORD: 'Historical Record',
  INTEGRATIONS: 'Integrations',
  MISCELLANEOUS: 'Miscellaneous'
};

// Drives the order of the filter chips on the product updates page.
export const NEWS_CATEGORY_OPTIONS = [
  NEWS_CATEGORIES.MARKET_DATA,
  NEWS_CATEGORIES.ESTIMATE,
  NEWS_CATEGORIES.COMPARISON,
  NEWS_CATEGORIES.BID_PACKAGE,
  NEWS_CATEGORIES.HISTORICAL_RECORD,
  NEWS_CATEGORIES.INTEGRATIONS,
  NEWS_CATEGORIES.MISCELLANEOUS
];

// --- Release tooltips ---------------------------------------------------------------------
//
// A feature id is the contract between a product update and the DOM. A news item in
// `_helpers.js` lists the ids it announces; the component that owns each element carries the
// matching `data-feature-id`. Both sides import from here, so a rename cannot half-land and
// leave an update pointing at nothing.
//
// Naming: `<area>-<thing>-<element>`. One update may name several ids — the same feature
// often exists on both a template and an estimate, and the update decides which of those
// are worth pointing at rather than always taking both.
export const FEATURE_IDS = {
  ESTIMATE_VALUE_ENGINEERING_TAB: 'estimate-value-engineering-tab',
  ESTIMATE_SCENARIO_CHART_BUTTON: 'estimate-scenario-chart-button',
  PRECON_TEAM_NAV_ITEM: 'precon-team-nav-item',
  BID_PACKAGE_BID_TAG_CELL: 'bid-package-bid-tag-cell',
  BID_PACKAGE_SORT_TRIGGER: 'bid-package-sort-trigger',
  BID_PACKAGE_VIEWING_TRIGGER: 'bid-package-viewing-trigger',
  BID_PACKAGE_ASSIGN_TRIGGER: 'bid-package-assign-trigger',
  BID_PACKAGE_ASSIGN_CELL: 'bid-package-assign-cell',
  UNIT_COST_HISTORY_NAV_ITEM: 'unit-cost-history-nav-item',
  ESTIMATE_DETAILED_BUDGET_COLUMNS_TRIGGER: 'estimate-detailed-budget-columns-trigger',
  ESTIMATE_FILES_TAB: 'estimate-files-tab',
  ESTIMATE_COST_FIELD_TOTAL_COST_CELL: 'estimate-cost-field-total-cost-cell',
  MARKET_VALUE_TYPE_BUTTON: 'market-value-type-button',
  GCGR_SCHEDULE_ZOOM_SLIDER: 'gcgr-schedule-zoom-slider',
  ESTIMATE_COST_SUB_FIELD_UNIT_COST_CELL: 'estimate-cost-sub-field-unit-cost-cell',
  BID_PACKAGE_QUOTE_REVIEW_ROW: 'bid-package-quote-review-row',
  ESTIMATE_ADD_COMP_BUTTON: 'estimate-add-comp-button',
  ESTIMATE_ADD_DRAWING_DROPZONE: 'estimate-add-drawing-dropzone',
  BID_QUOTE_DRAW_TRIGGER: 'bid-quote-draw-trigger',
  ESTIMATE_COMPARE_TAB: 'estimate-compare-tab',
  COMPARISON_SORT_TRIGGER: 'comparison-sort-trigger',
  COMPARISON_VIEWING_TRIGGER: 'comparison-viewing-trigger',
  COMPARISON_ADD_PARAMETER_BUTTON: 'comparison-add-parameter-button'
};

export const FEATURE_ANNOUNCEMENT_ATTRIBUTE = 'data-feature-id';

// Carried by the tooltip's card and its spotlight dim. Both are portalled to the body, so a
// Sheet or Dialog that is open when a tooltip points into it reads a press on either as a
// press outside itself and closes — taking the announced control away the moment the user
// answers the tooltip. A surface that can hold an announced control checks for this with
// `isFeatureAnnouncementEvent` in its `onInteractOutside`.
export const FEATURE_ANNOUNCEMENT_LAYER_ATTRIBUTE = 'data-feature-announcement-layer';

// Someone back after a quiet month should not be met with every tooltip released while they
// were away, so an update stops announcing itself once it is this old. It stays on the
// product updates page forever either way — this window only governs the tooltip.
export const FEATURE_ANNOUNCEMENT_MAX_AGE_DAYS = 30;

// Dismissals are per-user-per-browser and carry no server state, which is the whole reason
// this is cheap enough to be worth doing. The cost is that a new browser shows them again.
export const FEATURE_ANNOUNCEMENT_STORAGE_KEY = 'zebel-dismissed-feature-announcements';

// The way out, for somebody who does not want to be pointed at anything. Toggled from the
// product updates page, which is where a user who is already reading release notes will look
// for it. Kept separate from the dismissal list so turning tips back on does not resurrect
// every update they have already waved away.
export const FEATURE_ANNOUNCEMENT_ENABLED_STORAGE_KEY = 'zebel-feature-tips-enabled';

export const FEATURE_ANNOUNCEMENT_SUPPORT_EMAIL = 'support@zebel.io';
